export default {
  banner: {
    title: "Multi-Tenant",
    subtitle:
      "Authing enables enterprises to quickly build a multi-tenant management architecture. It eliminates the need to build from scratch and quickly implements a development framework with data isolation features.",
    img: "tenant-banner-img1-en.png",
    data: {
      item1: "Accelerate product development",
      item2: "Reduced maintenance costs",
      item3: "Guaranteed data isolation security",
      item4: "Increased expansion flexibility",
    },
  },
  scene: {
    title: "Typical Multi-Tenant Scenarios",
    item1: {
      img: "https://files.authing.co/authing-website/tenant-enterprise-en.png",
      title: `I'm a "SaaS company for enterprises"`,
      list1:
        "Serving multiple enterprise clients who require independent data and configuration, while sharing a set of resource systems. ",
      list2:
        "Building multi-tenant architecture from scratch is time-consuming and expensive.",
    },
    item2: {
      img: "https://files.authing.co/authing-website/tenant-group-en.png",
      title: `I'm a "Large group with multiple subsidiaries"`,
      list1:
        "Need to manage scattered subsidiaries uniformly while ensuring each subsidiary's data is independent of the others. ",
      list2: `The group is hierarchically complex and requires a lot of manpower to achieve "group data sharing and subsidiary data independence."`,
    },
    item3: {
      img: "https://files.authing.co/authing-website/tenant-user-en.png",
      title: `I'm a "Platform for individual consumers"`,
      list1:
        "Selling through distributors to individual users who require flexible and free resource and data isolation features.",
      list2:
        "Each distributor needs to be able to control allocation of different resource permissions and maintain independent data. ",
      list3:
        "Common applications include developer platforms and collaborative platforms for multiple users.",
    },
  },
  feature: {
    item1: {
      title: "Mature multi-tenancy architecture for quick data isolation",
      descript:
        "Authing offers reusable and scalable multi-tenancy architecture, eliminating the need for in-house development of complex multi-tenancy logic. Tenants can have independent data, permissions, and settings by connecting directly to Authing.",
    },
    item2: {
      title: "Comprehensive multi-tenant console to reduce managing costs",
      descript:
        "As administrators of multiple tenants, enterprises can easily create/import tenants, configure associated applications and identity sources, and define isolation and audit user behavior among tenants with Authing's foundational identity capabilities.",
    },
    item3: {
      title:
        "Powerful API extension capability for increased management flexibility",
      descript:
        "Authing provides PaaS-like integration for tenant resource management, including user, application, and tenant configuration, through its APIs in the administrators' own system interface.",
    },
    item4: {
      title: "Customizable login configuration to meet brand requirements ",
      descript:
        "Authing allows tenants to customize login interfaces and authentication methods, ensuring that the login module aligns with independent brand requirements and user login habits.",
    },
    item5: {
      title: "Independent tenant console for empowering user operations",
      descript:
        "With Authing's tenant console, tenant administrators can manage members within their organization, provide appropriate permissions to different members, and track tenant member usage through dashboards.",
    },
  },
  expend: {
    title: "Flexible Multi-Tenant Based on IDaaS",
    img: "https://files.authing.co/authing-website/tenant-expend-en.png",
  },
  customer: {
    title: "Leveraging IDaaS to Build Flexible Multi-tenant",
    item1: {
      title1: "Forchange",
      descript1: "Specialize in automated teaching technology",
      title2:
        "Enhancing operational efficiency and focusing on business development",
      descript2:
        "Authing's multi-tenant function empowers each distributor with an independent authentication system that they can customize and manage user access with. This significantly improves our distributor management and brings us huge profits.",
    },
    item2: {
      title1: "Visual Dynamics",
      descript1:
        "Pioneers in domestic industrial-grade new energy SaaS integration services.",
      title2:
        "Efficiently building a tenant system to quickly deploy applications",
      descript2:
        "With Authing's multi-tenant function, we built an enterprise SaaS multi-tenant model quickly and efficiently, empowering our corporate clients to self-administer and saving us significant costs on multi-tenant maintenance and construction.",
    },
    item3: {
      title1: "Regrello",
      descript1:
        "Developing supply chain workflow tools for inter-company collaboration.",
      title2: "Smoothly migrating tenants to accelerate market expansion",
      descript2:
        "We needed a localized service provider when expanding into the Chinese market. We selected Authing for their easy-to-use product, which facilitated our smooth migration over multiple tenants, fulfilling Chinese market demands.",
    },
  },
};
